"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialAssessmentFrequencyGuideline = void 0;
const Field_type_1 = require("../../../types/Field.type");
const FinancialAssessmentFrequency_1 = require("../../enm/FinancialAssessmentFrequency");
exports.FinancialAssessmentFrequencyGuideline = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.financial_assessment_frequency.label',
    fallbackLabel: 'Do you perform dedicated financial assessments on merchants aside from potentially involving non-specific financial figures in the credit risk assessment (such as total revenue or profit shown on a credit report)? What is the frequency guideline for them?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Enum,
    options: FinancialAssessmentFrequency_1.FinancialAssessmentFrequencyRef.options,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
